import React, { useEffect, useState } from "react";
import medicinesImg from "../../../Assets/Icons/medicine.svg";
import { message, Modal, Select } from "antd";
import PharmacyService from "../../../Services/PharmacyService";
function ShareMedicine({
  medicines,
  appointmentDetails,
  medicineOrders,
  setMedicineOrders,
  selectedPharmacy,
  setSelectedPharmacy,
}) {
  const [pharmaList, setPharmaList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [save, setSave] = useState(false);
  const [loading, setLoading] = useState(false);

  const showModal = async () => {
    if (
      !appointmentDetails.drugPrescriptionStatus ||
      appointmentDetails.drugPrescriptionStatus === "Decline" ||
      appointmentDetails.drugPrescriptionStatus === ""
    ) {
      if (medicines.length === 0) {
        message.error("Add Medicines in consultation to share order");
        return;
      }
      setLoading(true);
      try {
        let pharmaListPayload = {
          userId: appointmentDetails.userId,
          status: 1,
        };

        let pharmaList1 =
          await PharmacyService.GetPharmacyList(pharmaListPayload);
        setPharmaList(pharmaList1.data);
        setIsModalOpen(true);
      } catch (error) {
        message.error("Error");
      } finally {
        setLoading(false);
      }
    } else {
      message.error("Medicine Order is Already Placed");
    }
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSelectedItem = (selectedId) => {
    const selectedObj = pharmaList.find((item) => item.id === selectedId);
    setSelectedPharmacy(selectedObj);
  };

  const onMedicineOrderSend = async () => {
    message.info(
      "Medicine Order Triggered , order will be send to pharmacy when consultation ended",
    );
    setMedicineOrders(true);
    setIsModalOpen(false);
  };

  const handleCancelOrder = () => {
    setMedicineOrders(false);
    setSelectedPharmacy(null);
    message.info("Medicine Order cancelled");
  };

  useEffect(() => {
    if (medicines.length == 0) {
      setMedicineOrders(false);
      setSelectedPharmacy(null);
    }
  }, [medicines]);
  return (
    <>
      {loading && (
        <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="spinner"></div>
        </div>
      )}
      <div className="relative flex gap-1" title="Medicine Order">
        <div
          onClick={showModal}
          className={`w-[28px] h-[28px] flex items-center justify-center rounded-full transition-all duration-300 ${medicines.length > 0
              ? "bg-brand-primaryColor text-white"
              : "bg-[#E1E1E1]"
            }`}
        >
          <img
            src={medicinesImg}
            alt={"LabImg"}
            className={`transition-all duration-300 ${medicines.length > 0 ? "filter invert fill-white" : ""
              }`}
          />
        </div>

        {/* 🔴 Badge */}
        {medicineOrders && medicines.length > 0 && (
          <div
            onClick={handleCancelOrder}
            className="absolute -top-1 -right-1 
                       w-5 h-5 
                       flex items-center justify-center 
                       text-[10px] font-bold 
                       bg-rose-500 text-white 
                       rounded-full 
                       shadow-md
                       cursor-pointer 
                       hover:bg-rose-600 
                       transition-all duration-200"
          >
            ✕
          </div>
        )}
      </div>

      <Modal
        title="Medicine Order"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
      >
        {save && (
          <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="spinner"></div>
          </div>
        )}
        <div className="flex gap-2">
          <Select
            className="w-[80%]"
            value={selectedPharmacy?.id}
            onChange={handleSelectedItem}
          >
            {pharmaList?.map((pAndlList) => (
              <Select.Option key={pAndlList.id} value={pAndlList.id}>
                {pAndlList.pharmacyName}
              </Select.Option>
            ))}
          </Select>

          <button
            onClick={onMedicineOrderSend}
            className="p-1 rounded-md bg-[24, 159, 170] text-white font-semibold"
            disabled={save}
          >
            Order{" "}
          </button>
        </div>
      </Modal>
    </>
  );
}

export default ShareMedicine;
